import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

// MUI Imports
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
// Icons
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
// Others
import FileOverviewTable from "../../../../utils/FileOverviewTable";

const FileHistory = ({ loadErroredData, fileList, hideErrRecords, jobHistory_id }) => {
  const [searchTerm, setSeatchTerm] = useState("");

  const { editJob } = useSelector((state) => state.dataPipeline);
  const { jobId, JobType } = useMemo(() => {
    return { JobType: Number(editJob?.data?.type || 1), jobId: Number(editJob?.id || -1) };
  }, [editJob?.id, editJob?.data?.type]);

  const $DataSourceList = useMemo(
    () => (JobType === 1 ? [...new Set(fileList.map((file) => file.SOURCE))] : []),
    [JobType, fileList]
  );

  const $filteredData = useMemo(() => {
    const search = searchTerm?.toLowerCase();
    return searchTerm
      ? fileList.filter(
          ({ FILEPATH, SOURCE, status }) =>
            FILEPATH?.toLowerCase().includes(search) ||
            SOURCE?.toLowerCase().includes(search) ||
            status?.toLowerCase().includes(search)
        )
      : fileList;
  }, [fileList, searchTerm]);

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 0,
          md: 6
        }}></Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <TextField
          variant="standard"
          placeholder="Search"
          value={searchTerm}
          id="outlined-size-small"
          InputProps={{
            startAdornment: <SearchIcon color="primary" sx={{ marginRight: "5px" }} />,
            ...(searchTerm && {
              endAdornment: (
                <IconButton
                  onClick={() => {
                    setSeatchTerm("");
                  }}
                  size="small"
                >
                  <ClearIcon color="primary" />
                </IconButton>
              ),
            }),
          }}
          onChange={(e) => setSeatchTerm(e.target.value)}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        />
      </Grid>
      <Grid size={12}>
        <FileOverviewTable
          JobType={JobType}
          data={$filteredData}
          hideErrRecords={hideErrRecords}
          DataSources={$DataSourceList}
          loadErroredData={loadErroredData}
          jobHistoryId={jobHistory_id}
          jobId={jobId}
        />
      </Grid>
    </Grid>
  );
};

FileHistory.propTypes = {
  fileList: PropTypes.array.isRequired,
  loadErroredData: PropTypes.func.isRequired,
  jobHistory_id: PropTypes.number.isRequired,
};

export default FileHistory;
